import React, { useState } from "react";
import {
  Abc,
  AccountBalance,
  DoubleArrow,
  DynamicFeed,
  Password,
  Store,
  Edit,
  Delete,
} from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";
import { Tooltip, Drawer } from "@mui/material";
import { customAPI } from "services/utils/CustomAPI";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { EditPaymentBank } from "./EditPaymentBank";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { useForm } from "react-hook-form";
import {
  deleteText,
  deleteMessage,
  unSavedText,
  unSavedMessage,
  drawerStyle,
  editIconStyle,
  deleteIconStyle,
  doubleArrowStyle,
  parentBoxStyle,
  childBoxStyleSpaceBetween,
} from "services/constants";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Card,
  Grid,
  Avatar,
  CardContent,
} from "@mui/material";

export const ViewPaymentBank = ({
  onClose,
  individualBankData,
  reCallApi,
  setGetId,
  setHanldeLoader,
  screenAccess,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isDeactivateButton, setIsDeactivateButton] = useState(false);
  const { handleSubmit, reset } = useForm({
    mode: "onBlur",
  });

  const bankDetailsData = [
    {
      id: 1,
      label: "Bank Name",
      value: individualBankData?.bank_name,
      icon: AccountBalance,
      variant: "blue",
    },
    {
      id: 2,
      label: "Nick Name",
      value: individualBankData?.nick_name,
      icon: DynamicFeed,
      variant: "red",
    },
    {
      id: 3,
      label: "Account Number",
      value: individualBankData?.bank_account_number,
      icon: Abc,
      variant: "grey",
    },
    {
      id: 4,
      label: "Confirm Account Number",
      value: individualBankData?.bank_account_number,
      icon: Abc,
      variant: "purple",
    },

    {
      id: 5,
      label: "Branch Name",
      value: individualBankData?.bank_branch,
      icon: Store,
      variant: "green",
    },

    {
      id: 6,
      label: "IFSC Code",
      value: individualBankData?.bank_ifsc_code,
      icon: Password,
      variant: "brown",
    },
  ];

  const hanldeEditPanel = () => {
    setIsEditPanelOpen(true);
  };

  const onSubmit = async (data) => {
    const response = await customAPI(
      `${domain}payroll/setup/paymentbank/payment-bank/${individualBankData?.id}`,
      "PATCH",
      {
        is_deleted: true,
      }
    );
    if (response.ok) {
      showToast("error", response?.responseDetails?.message);
      setHanldeLoader(false);
      reCallApi(true);
      onClose();
    }
  };

  const handleClosePanel = () => {
    if (hasUnsavedChanges) {
      setShowConfirmationDialog(true);
    } else {
      setIsEditPanelOpen(false);
    }
  };

  const handleConfirmClose = () => {
    setShowConfirmationDialog(false);
    setIsEditPanelOpen(false);
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    reset();
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={
            isDeactivateButton ? handleSubmit(onSubmit) : handleConfirmClose
          }
          title={isDeactivateButton ? deleteText : unSavedText}
          message={
            isDeactivateButton
              ? deleteMessage(individualBankData?.bank_name)
              : unSavedMessage
          }
          confirmText={isDeactivateButton ? "Delete" : "Exit"}
          cancelText="Cancel"
        />

        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Delete" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        setShowConfirmationDialog(true);
                        setIsDeactivateButton(true);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to inactivate payrun cycle `
                        );
                      }
                    }}
                    sx={deleteIconStyle}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        hanldeEditPanel();
                        setIsDeactivateButton(false);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit payrun cycle`
                        );
                      }
                    }}
                    sx={editIconStyle}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {individualBankData?.bank_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View your payment bank details.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,
              mt: 4,
            }}
          >
            <Grid container spacing={{ xs: 4, md: 6 }}>
              {bankDetailsData.map((item) => {
                const IconComponent = item.icon;
                const isBlue = item.variant === "blue";

                return (
                  <Grid item xs={12} sm={6} key={item.id}>
                    <Card
                      sx={{
                        bgcolor: "#3c73e70d",
                        borderRadius: "5px",
                        border: 0,
                        boxShadow: "0px 4px 4px #00000040",
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 35,
                              height: 35,
                              bgcolor: isBlue ? "#3c73e71a" : "#bd09091a",
                              border: `0.5px solid ${item?.variant}`,
                              boxShadow: "0px 1px 2px #00000040",
                              color: item?.variant,
                            }}
                          >
                            <IconComponent
                              size={18}
                              color={isBlue ? "#3c73e7" : "#d71515"}
                            />
                          </Avatar>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              mb: "auto",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Box>
                        <Box sx={{ pl: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              color: "#32325D",
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={() => {
          handleClosePanel();
        }}
        sx={drawerStyle}
      >
        <EditPaymentBank
          onClose={handleClosePanel}
          individualBankData={individualBankData}
          reCallApi={reCallApi}
          setGetId={setGetId}
          setIsEditPanelOpen={setIsEditPanelOpen}
          setHanldeLoader={setHanldeLoader}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Drawer>
    </>
  );
};
